import React, { Fragment, useState, useEffect } from 'react';
import './relatedContents.scss';
import axios from 'axios';
import logo from '../../assets/logo.png';
function RelatedContents() {
  const [relatedContentsData, setRelatedContentsData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await axios(
          'https://cdn.courageousstudios.com/assets/sponsorcontent/intel/intel2023RelatedContents.json'
        );
        const data = JSON.parse(JSON.stringify(result.data));
        setRelatedContentsData(data.hub);
      } catch (error) {
        console.log('theres an error', error);
      }
    };
    fetchData();
  }, []);

  return (
    <section className="relatedContents">
      <div className="relatedContents-wrapper">
        <div className="relatedContents__tiles">
          {relatedContentsData &&
            relatedContentsData.map((data, i) => {
              return (
                <Fragment key={data.content}>
                  <div
                    className={`relatedContents__tile relatedContents__tile-${data.content}`}
                    key={i}
                    style={{ backgroundImage: `url(${data.background})` }}
                  >
                    <div className="relatedContents__tile--contents relatedContents__tile__content">
                      <h4>{data.title}</h4>

                      <a href={data.url} target="_blank" rel="sponsored">
                        {data.button}
                      </a>
                    </div>
                  </div>
                </Fragment>
              );
            })}
        </div>
      </div>
      <img src={logo} className="relatedContents__logo" alt="It Starts With Intel Logo" />
    </section>
  );
}

export default RelatedContents;
